import { render, staticRenderFns } from "./countPten.vue?vue&type=template&id=23f8d220&scoped=true"
import script from "./countPten.vue?vue&type=script&lang=js"
export * from "./countPten.vue?vue&type=script&lang=js"
import style0 from "./countPten.vue?vue&type=style&index=0&id=23f8d220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f8d220",
  null
  
)

export default component.exports